import { ElementRef } from '@angular/core'

export abstract class BaseHtmlDirective {
  constructor(private _elRef: ElementRef) {}

  get element() {
    return this._elRef.nativeElement
  }
}
